import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axiosInstance, { apiAxios } from "../../utils/axios";

const initialState = {
  user: null, // State chứa thông tin người dùng
  isLoggedIn: false,
  token: "",
  isLoading: false,
  user_id: null,
  role: "",
  email: "",
  error: false,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateIsLoading(state, action) {
      state.error = action.payload.error;
      state.isLoading = action.payload.isLoading;
    },
    logIn(state, action) {
      state.isLoggedIn = action.payload.isLoggedIn;
      state.user_id = action.payload.user_id;
      state.role = action.payload.role;
      state.email = action.payload.email;
      state.token = action.payload.token;
    },
    signOut(state, action) {
      state.isLoggedIn = false;
      state.user_id = null;
      state.role = "";
      state.token = "";
      state.email = "";
    },
    resetPassword(state, action) {
      state.isLoadingResetPassword = action.payload.isLoadingResetPassword;
      state.status = action.payload.status;
    },
    newPassword(state, action) {
      state.isLoadingNewPassword = action.payload.isLoadingNewPassword;
      state.status = action.payload.status;
    },
  },
});

// Reducer
export default slice.reducer;

// Async actions
export function ForgotPassword(formValues) {
  return async (dispatch) => {
    dispatch(slice.actions.updateIsLoading({ isLoading: true, error: false }));

    try {
      await axiosInstance.post("/api/forgot-password", formValues);
      dispatch(slice.actions.updateIsLoading({ isLoading: false, error: false }));
      toast.success("Password reset link sent to your email!");
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.updateIsLoading({ isLoading: false, error: true }));
      toast.error("Failed to send password reset link. Please try again.");
    }
  };
}

export function NewPassword(formValues) {
  return async (dispatch) => {
    dispatch(slice.actions.updateIsLoading({ isLoading: true, error: false }));

    try {
      const response = await axiosInstance.post("/auth/reset-password", formValues);
      dispatch(slice.actions.logIn({
        isLoggedIn: true,
        token: response.data.token,
        user_id: response.data.user_id,
        role: response.data.role,
        email: response.data.email,
        user: response.data.user,
      }));
      dispatch(slice.actions.updateIsLoading({ isLoading: false, error: false }));
      toast.success("Password reset successfully!");
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.updateIsLoading({ isLoading: false, error: true }));
      toast.error("Failed to reset password. Please try again.");
    }
  };
}

export function ResetPassword(formValues) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.resetPassword({ isLoadingResetPassword: true }));

    await apiAxios
      .post(
        "/send_email",
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTimeout(() => {
          dispatch(
            slice.actions.resetPassword({
              isLoadingResetPassword: false,
              status: response.data.status,
            })
          );
        }, 2000);
      })
      .catch((error, response) => {
        setTimeout(() => {
          dispatch(
            slice.actions.resetPassword({
              isLoadingResetPassword: false,
              status: response.data.status,
            })
          );
        }, 2000);
      });
  };
}

export function LoginUser(formValues) {
  return async (dispatch, getState) => {
    // Make API call here

    dispatch(slice.actions.updateIsLoading({ isLoading: true, error: false }));

    await apiAxios
      .post(
        "/login",
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        dispatch(
          slice.actions.logIn({
            user: response.data.user, // Lưu thông tin user đầy đủ
            isLoggedIn: true,
            user_id: response.data.user_id,
            role: response.data.role,
          })
        );
        window.localStorage.setItem("role", response.data.role);

        dispatch(
          slice.actions.updateIsLoading({ isLoading: false, error: false })
        );
      })
      .catch(function (error) {
        console.log(error);

        // Hiển thị thông báo lỗi
        toast.error("Incorrect password");

        dispatch(
          slice.actions.updateIsLoading({ isLoading: false, error: true })
        );
      });
  };
}

export function LogoutUser() {
  return async (dispatch, getState) => {
    window.localStorage.removeItem("role");
    dispatch(slice.actions.signOut());

  };
}
